import React from 'react'
import { type IOffer } from '../../../../store/slices/offersSlice';
import { type Unit } from '../../../../store/slices/unitsSlice';
import { List, Steps } from 'antd';
import StepComponent from './StepComponent';
interface IProps {
    offer: IOffer
    unit: Unit
    isMyUnit: boolean
}

export default function GroupTimelineOfferBetweenAgents({ offer, unit, isMyUnit }: IProps): JSX.Element {
    const process = 0
    const offerStatuses = offer?.attributes?.Statuses
    const isAgentUnit = unit?.attributes?.Statuses.includes('Door close') || unit?.attributes?.Statuses.includes('Agent Unit')
    const isLandlordUnit = unit?.attributes?.Statuses.includes('Landlord Unit')



    let stsText = null
    const textsOfferTimeline = {
        underReview: isMyUnit ? `Confirm the offer from the ${isLandlordUnit ? "landlord" : "agent"}` : 'Wait for the offer to be approved',
        descriptionUnderReview: isMyUnit
            ? `Review the offer details carefully and confirm if everything is correct. If you have any questions, contact the ${isLandlordUnit ? "landlord" : "agent"} for clarification.`
            : `Your offer is currently under review. Please wait for the ${isLandlordUnit ? "landlord" : "agent"} to approve or provide feedback.`,

        // stepConfirmed: isMyUnit ? 'You confirmed the agent’s offer' : 'You have a confirmed offer',
        // descriptionConfirmed: isMyUnit
        //     ? 'The offer has been confirmed. Ensure all terms are met and prepare to close the deal.'
        //     : 'Your offer has been confirmed by the agent. The deal is now in its final stages.',


        stepConfirmed: isMyUnit ? 'You confirmed the offer.' : `The ${isLandlordUnit ? "landlord" : "agent"} confirmed your offer.`,
        descriptionConfirmed: isMyUnit ? 'Review all the details, use the chat to negotiate terms. If everything looks good, close the deal.' : 'Use the chat to negotiate terms and wait for the deal to be completed.',

        stepCompleted: 'Deal successfully closed',
        descriptionCompleted: 'Congratulations on closing another deal! Celebrate your success and start working on the next one with the BSO Club!',
    };



    if (offerStatuses?.includes('Negotiated by agent')) {
        textsOfferTimeline.underReview = isMyUnit ? `You have a new deal from another ${isLandlordUnit ? "landlord" : "agent"}` : `You proposed a new agreement to the ${isLandlordUnit ? "landlord" : "agent"}`;
        stsText = isMyUnit ? `Negotiated by another agent` : `Negotiated by yourself`;
        textsOfferTimeline.descriptionUnderReview = 'Review the offer details and make a decision. Use the chat to clarify the terms.';
    } else if (offerStatuses?.includes('Negotiated by other agent')) {
        textsOfferTimeline.underReview = isMyUnit ? `You proposed a new agreement to the agent` : `You have a new deal from another agent`;
        stsText = isMyUnit ? 'Negotiated by yourself' : `Negotiated by another agent`;
        textsOfferTimeline.descriptionUnderReview = `Review the offer details and make a decision. Use the chat to clarify the terms.`;
    } else if (offerStatuses?.includes('Negotiated by landlord')) {
        textsOfferTimeline.underReview = isMyUnit ? `You proposed a new agreement to the landlord` : `You have a new deal from landlord`;
        stsText = isMyUnit ? 'Negotiated by yourself' : `Negotiated by landlord`;
        textsOfferTimeline.descriptionUnderReview = `Review the offer details and make a decision. Use the chat to clarify the terms.`;
    }


    if (offerStatuses?.includes('Canceled')) {
        textsOfferTimeline.stepCompleted = isMyUnit ? `The ${isLandlordUnit ? "landlord" : "agent"} has canceled this offer` : 'You have canceled this offer';
        textsOfferTimeline.descriptionCompleted = isMyUnit ? `The offer was canceled by the ${isLandlordUnit ? "landlord" : "agent"}. You can create a new offer or contact the ${isLandlordUnit ? "landlord" : "agent"} for further details.` : `You have canceled this offer. If this was a mistake, please contact the ${isLandlordUnit ? "landlord" : "agent"} to clarify.`;
    } else if (offerStatuses?.includes('Canceled by other agent')) {
        textsOfferTimeline.stepCompleted = isMyUnit ? 'You have canceled this offer' : `The ${"agent"} has canceled this offer`;
        textsOfferTimeline.descriptionCompleted = isMyUnit ? `You have canceled this offer. If this was a mistake, please contact the ${"agent"} to clarify.` : `The ${"agent"} has canceled this offer. You can create a new offer or contact the ${"agent"} for further details.`;
    }


    const data = [

        ...(!(offerStatuses[0].includes("Canceled") || offerStatuses[0].includes("Rejected")) ? [

            {
                title: 'Under review',
                status: undefined,
                icon: <i className="ki-duotone ki-loading fs-5x">
                    <span className="path1"></span>
                    <span className="path2"></span>
                </i>,
                iconProcess: <i className="ki-duotone ki-loading fs-5x text-success">
                    <span className="path1"></span>
                    <span className="path2"></span>
                </i>,
                description: 'The initial stage where terms are being discussed and adjusted, where the deal is being processed.',
                statuses: ['In-process', 'Negotiated by agent', 'Negotiated by other agent', 'Negotiated by landlord'],
                items: [{
                    title: <StepComponent
                        title={textsOfferTimeline.underReview + '\n' + textsOfferTimeline.descriptionUnderReview}
                        process={0}
                        currentProcess={process}
                        statuses={stsText != null ? [stsText] : offerStatuses}
                        negotiationReason={process === 0 ? offer?.attributes?.RejectReason ?? undefined : undefined}
                    />
                }]
            },
            {
                title: 'Conformations & Finalization',
                status: undefined,
                icon: <i className="ki-duotone ki-scroll fs-5x">
                    <span className="path1"></span>
                    <span className="path2"></span>
                    <span className="path3"></span>
                </i>, iconProcess: <i className="ki-duotone ki-scroll fs-5x text-success">
                    <span className="path1"></span>
                    <span className="path2"></span>
                    <span className="path3"></span>
                </i>,
                description: 'This stage involves confirming the terms of the deal, agreeing on final conditions, and preparing for the next steps.',
                statuses: [
                    'Confirmed'
                ],
                items: [{
                    title: <StepComponent
                        title={textsOfferTimeline.stepConfirmed + '\n' + textsOfferTimeline.descriptionConfirmed}
                        process={0}
                        currentProcess={process}
                        statuses={offerStatuses}

                    />
                }]
            }] : []),
        {
            title: 'Closure',
            status: undefined,
            icon: <i className="ki-duotone ki-check fs-5x"></i>,
            iconProcess: <i className="ki-duotone ki-check fs-5x text-success"></i>,
            description: 'The stage where the deal is closed either completed.',
            statuses: ['Completed', 'Rejected', 'Canceled', 'Canceled by BSO', 'Canceled by agent', 'Canceled by yourself', 'Canceled by other agent'],
            items: [{
                title: <StepComponent
                    title={textsOfferTimeline.stepCompleted}
                    process={0}
                    description={textsOfferTimeline.descriptionCompleted}
                    currentProcess={process}
                    statuses={offerStatuses}
                    rejectReason={process === 0 ? offer?.attributes?.RejectReason ?? undefined : undefined}
                />
            },]
        },
    ];

    const activeStepIndex = data.findIndex(step =>
        step.statuses.includes(offerStatuses[0]) ||
        (step.title === 'Conformations & Finalization'
            && !step.statuses.includes(offerStatuses[0])
            && Boolean(offer?.attributes?.StatusUpdateDescription))
    );

    return (
        <div className='my-4 pt-2' style={{ maxWidth: '450px', width: '100%' }}>
            <List
                itemLayout="horizontal"
                dataSource={data}
                renderItem={(group, index) => {
                    const isActive = index === activeStepIndex;
                    const currentProcess = process;
                    return (
                        <div className='d-flex flex-column'>
                            <List.Item >
                                <div className='d-flex flex-column w-100'>
                                    <List.Item.Meta
                                        style={{
                                            lineHeight: 0.1
                                        }}
                                        avatar={
                                            <div className={`d-flex align-items-center justify-content-center w-100`}>
                                                {isActive ?
                                                    offerStatuses[0].includes("Completed") ?
                                                        <span className={'border border-2 align-middle p-7 position-relative border-success  rounded rounded-circle'}>
                                                        </span> : offerStatuses[0].includes("Canceled") || offerStatuses[0].includes("Rejected") ?
                                                            <span className={'border border-2 align-middle p-7 position-relative border-danger  rounded rounded-circle'}>
                                                            </span> :
                                                            < span className={'spinner-border spinner-border-sm align-middle p-7 position-relative text-success'}>
                                                            </span>
                                                    : null}
                                                <span className={`position-${isActive ? 'absolute' : 'static'}`}>
                                                    {isActive ? offerStatuses[0].includes("Canceled") || offerStatuses[0].includes("Rejected") ? <i className="ki-duotone ki-cross-circle fs-5x text-danger">
                                                        <span className="path1"></span>
                                                        <span className="path2"></span>
                                                    </i> : group.iconProcess : group.icon}
                                                </span>
                                            </div>
                                        }
                                        title={<div className='lh-1'><span className='lh-1 fs-4'>{group.title.toUpperCase()}</span></div>}
                                        description={<div className='lh-1'><span className='lh-1 fs-7'>{group.description}</span></div>}
                                    />
                                    <div className='ps-4 ms-4 mt-2'>
                                        {isActive &&
                                            <>
                                                <Steps
                                                    className='w-100'
                                                    style={{ marginTop: 8, width: '100%' }}
                                                    current={currentProcess}
                                                    items={group.items}

                                                />
                                            </>
                                        }
                                    </div>
                                </div>
                            </List.Item>
                        </div>
                    )
                }}
            />
        </div>
    )
}
